import axios from 'axios';
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import { publicSurveyService } from '../services/publicSurvey.service';

export function usePublicSurveyParticipation() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();

  const startParticipation = async (surveyId: string) => {
    if (!isAuthenticated) {
      navigate('/login', {
        state: {
          participationSurveyId: surveyId,
          fromPublicHome: true,
        },
      });
      return;
    }

    try {
      const intent = await publicSurveyService.startParticipationIntent(surveyId);

      if (intent.nextStep === 'GO_TO_RESPONSE_FORM' && intent.responseFormUrl) {
        navigate(intent.responseFormUrl);
        return;
      }

      if (intent.nextStep === 'VERIFY_ACCOUNT') {
        message.warning(intent.message || 'Confirme sua conta antes de responder.');
        navigate('/confirm-account', {
          state: {
            email: user?.email,
            participationSurveyId: surveyId,
          },
        });
        return;
      }

      message.error(intent.message || 'Esta pesquisa não está mais ativa.');
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response?.status === 401) {
          navigate('/login', {
            state: {
              participationSurveyId: surveyId,
              fromPublicHome: true,
            },
          });
          return;
        }

        if (error.response?.status === 403) {
          message.warning('Confirme sua conta para continuar.');
          navigate('/confirm-account', {
            state: {
              email: user?.email,
              participationSurveyId: surveyId,
            },
          });
          return;
        }

        if (error.response?.status === 409) {
          message.error('Esta pesquisa não está mais disponível para participação.');
          return;
        }
      }

      message.error('Não foi possível iniciar sua participação agora.');
    }
  };

  return { startParticipation };
}
